import React, { CSSProperties } from "react";

// Common
import { Table } from "react-lib/frameworks/Table";
import { ComponentPropsGetterR } from "react-table-6";


// type
type TableIssueListProps = {
  // func
  onGetTrProps: ComponentPropsGetterR;
  // data
  data: any[]; // *
  style: CSSProperties;
};

const TableIssueList = (props: TableIssueListProps) => {
  return (
    <Table
      className="--rt-tbody-overflow-y-hidden"
      headers="ID, Tracker, Status, Priority, Subject, Assigned Division, Assign To, Causes and Solutions, Created, Updated, Project"
      keys="_id, tracker, status, priority, subject, assigned_division, assigned_to, solutions, created, updated, project"
      minRows={10}
      showPagination={false}
      sortable={false}
      style={props.style}
      data={props.data}
      widths="^60, ^100, ^100, ^100, ^300, ^150, ^250, ^250, ^200, ^200, ^150"
      getTrProps={props.onGetTrProps}
    />
  );
};

export default React.memo(TableIssueList);